/**
 * Every navigable location in the app, in one place. Components and guards
 * reference these constants instead of string literals so a route rename is a
 * single, type-checked edit.
 */
export const routePaths = {
  home: '/',
  login: '/login',

  team: {
    registration: '/team/registrierung',
    profile: '/team',
  },

  tournament: {
    schedule: '/spielplan',
    groups: '/gruppen',
    knockout: '/ko-phase',
    match: (matchId: string) => `/spiel/${matchId}`,
    matchPattern: '/spiel/:matchId',
  },

  admin: {
    root: '/admin',
    teams: '/admin/teams',
    matches: '/admin/spiele',
    conflicts: '/admin/konflikte',
    settings: '/admin/einstellungen',
  },

  presentation: '/live',
} as const;
